import { ServiceMaker, methods, services } from "@/services";
import Api from "@/services/service-v2";

export const adminLogin = (data) =>
  ServiceMaker("/users/admin/login", methods.POST, services.nipige, data);

export const partnerLogin = (data) =>
  ServiceMaker("/users/partner/login", methods.POST, services.nipige, data);

export const createPartnerService = (data) =>
  ServiceMaker("/users/partner", methods.POST, services.nipige, data);

export const listTenant = () =>
  ServiceMaker("/users/tenant/filter", methods.GET, services.nipige);

export const tenantConfig = (payload) =>
  ServiceMaker("/users/tenant/config", methods.POST, services.nipige, payload);

export const filterListTenant = (payload) =>
  ServiceMaker(
    `/users/tenant/filter?${payload.type}=${payload.data}`,
    methods.GET,
    services.nipige,
    payload
  );

export const getTenantListLite = () =>
  ServiceMaker(`/users/tenant/list-ids`, methods.GET, services.nipige);

export const updateTenant = (id, data) =>
  ServiceMaker(
    `/users/tenant/update-tenant/${id}`,
    methods.PUT,
    services.nipige,
    data
  );
export const updateKycStatus = (payload) =>
  ServiceMaker(
    `/users/admin/update-kyc-status/${payload.id}?status=${payload.status}`,
    methods.PUT,
    services.nipige
  );

export const getAdsCount = () =>
  ServiceMaker("/api/item/details/count", methods.GET, services.catalog);

export const createTenant = (data) =>
  ServiceMaker(`/users/tenant`, methods.POST, services.nipige, data);

export const listTenantSubAdmin = (payload) =>
  ServiceMaker(
    `/users/admin/list?limit=${payload.limit}&page=${payload.page}`,
    methods.GET,
    services.nipige,
    payload
  );

export const userToDelete = (payload) =>
  ServiceMaker(
    `/users/admin/delete/${payload}`,
    methods.DELETE,
    services.nipige
  );

export const createTenantSubAdmin = (data) =>
  ServiceMaker(`/users/admin`, methods.POST, services.nipige, data);

export const updateTenantSubAdmin = (id, data) =>
  ServiceMaker(
    `/users/admin/update-profile/${id}`,
    methods.PUT,
    services.nipige,
    data
  );

export const fetchKYCListByTenant = (Id) =>
  ServiceMaker(`/users/tenant/list-kyc/${Id}`, methods.GET, services.nipige);

export const uploadKYCByTenant = (data) =>
  ServiceMaker(`/users/tenant/submit-kyc`, methods.POST, services.nipige, data);

export const updatekycDoc = (data) =>
  ServiceMaker(
    `/users/admin/update-kyc/${data.userId}/${data.docId}`,
    methods.PUT,
    services.nipige,
    data.data
  );

export const uploadKYCByUser = (data) =>
  ServiceMaker(`/users/admin/submit-kyc`, methods.POST, services.nipige, data);

export const getAnalyticsConfig = () =>
  ServiceMaker(
    `/users/tenant/analytics`,
    methods.GET,
    services.nipige,
    null,
    false,
    true
  );

export const getTenantDetailByID = (payload) =>
  ServiceMaker(
    `/users/tenant/detail-by-id/${payload}`,
    methods.GET,
    services.nipige
  );

export const getTenantPreferences = (payload) =>
  ServiceMaker(
    `/users/tenant/get-preferences/${payload}`,
    methods.GET,
    services.nipige
  );

export const updateTenantPreferences = (payload) =>
  ServiceMaker(
    `/users/tenant/update-preferences/${payload.id}`,
    methods.POST,
    services.nipige,
    payload.data
  );

export const updatePreferencesTenant = (payload) =>
  ServiceMaker(
    `/users/tenant/update-preferences/${payload.id}`,
    methods.POST,
    services.nipige,
    payload.binding
  );

export const updateGatewayPreferencesTenant = (payload) =>
  ServiceMaker(
    `/users/tenant/update-preferences/${payload.id}`,
    methods.POST,
    services.nipige,
    payload.paymentMode
  );

export const setPaymentConfig = (payload) =>
  ServiceMaker(
    `/payments/config/set/${payload.id}`,
    methods.POST,
    services.master,
    payload.data
  );
export const getNotificantionData = () =>
  ServiceMaker(
    `/cms/thirdpartynotification/list-notification-thirdparty`,
    methods.GET,
    services.master
  );

export const getExtendedList = () =>
  Api().$http.post(`/cap/users/tenant/get-config`, {});

export const addExtendedTemplate = (data) =>
  Api().$http.post(`/cap/users/tenant/config`, data);

export const updateExtendedItem = (id, payload) =>
  Api().$http.put(`/cap/users/tenant/config/ext-attr/update/${id}`, payload);
export const deleteExtendedAttr = (payload) =>
  Api().$http.delete(`/cap/users/tenant/config/ext-attr/delete`, payload);
export const getDeleveryData = () =>
  Api().$http.get(`/cms/thirdparty/list-delivery-thirdparty`);
export const configureDunzo = (data) =>
  Api().$http.post(`/cap/users/tenant/config`, data);
export const getDeviceBindingData = (id) =>
  Api().$http.get(`/cap/users/tenant/get-preferences/${id}`);
export const getConfiguredListNotification = (id) =>
  Api().$http.get(`/smsemail/service-provider/list-by-tenant/${id}`);
export const configureNotification = (data) =>
  Api().$http.post(`/smsemail/service-provider/set`, data);
export const getServiceProviders = () =>
  Api().$http.get(`/smsemail/service-provider/list`);

export const getTenantAnalyticReport = (payload) =>
  Api().$http.post(`dashboard/analytic-report/filter`, payload);

export const updateStatus = (id, payload) =>
  Api().$http.patch(`cap/users/admin/update-status/${id}`, payload);

export const fetchKYCListByUser = (id) =>
  Api().$http.get(`cap/users/tenant/list-kyc/${id}`);

export const KYCPreferenceList = (id) =>
  Api().$http.get(`cap/users/tenant/get-preferences/${id}`);

export const updateKycPreference = (payload) =>
  Api().$http.post(
    `cap/users/tenant/update-preferences/${payload.id}`,
    payload.data
  );

export const fetchUserManagementDetail = (id) =>
  Api().$http.get(`cap/users/admin/detail/${id}`);

export const fetchSlugName = (payload) =>
  Api().$http.get(
    `/cap/users/tenant/get-tenant-config-by-subdomain?subdomain=${payload.subdomain}`
  );

export const fetchPaymentGatewayList = () =>
  Api().$http.get("/cms/thirdpartygateway/list-payment-gateway");

export const fetchPaymentGatewayConfigure = (payload) =>
  Api().$http.post(`/payments/config/set/${payload.tenantId}`, payload.data);

export const fetchConfiguredGatewayList = (id) =>
  Api().$http.get(`/payments/config/get/${id}`);

export const fetchB2bGatewayList = () =>
  Api().$http.get("/cms/thirdpartyprovider/list-provider-thirdparty");

export const fetchB2bGatewayConfigure = (payload) =>
  Api().$http.post("/cap/users/tenant/config", payload);

export const fetchB2bConfiguredGateway = (payload) =>
  Api().$http.post("/cap/users/tenant/get-config", payload);

export const getTenantDetailsBySubDomain = (payload) =>
  Api().$http.get(
    `/cap/users/tenant/get-tenant-config-by-subdomain?subdomain=${payload.subDomain}`,
    payload
  );
